import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withKeys as _withKeys, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[15px] sm:p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-[15px] sm:gap-[25px]" }
const _hoisted_4 = { class: "mb-[15px] sm:mb-0 sm:col-span-2" }
const _hoisted_5 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_6 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_7 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_8 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_9 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_10 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_11 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_12 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_13 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_14 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_15 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_16 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_17 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_18 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_19 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_20 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_21 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_22 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_23 = { class: "flex items-center mb-2" }
const _hoisted_24 = { class: "flex items-center mb-2" }
const _hoisted_25 = { class: "flex items-center" }
const _hoisted_26 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "sm:col-span-2 mb-[15px] sm:mb-[20px]" }
const _hoisted_29 = { class: "col-span-1 sm:col-span-2 mb-[15px] sm:mb-[20px]" }
const _hoisted_30 = { class: "grid grid-cols-10 sm:grid-cols-12 gap-2 sm:gap-3" }
const _hoisted_31 = { class: "col-span-8 sm:col-span-11" }
const _hoisted_32 = { class: "col-span-2 sm:col-span-1" }
const _hoisted_33 = {
  key: 0,
  class: "mt-[15px] flex flex-wrap"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 1,
  class: "text-gray-500 dark:text-gray-400 text-sm mt-[10px]"
}
const _hoisted_36 = { class: "col-span-1 sm:col-span-2 mb-[15px] sm:mb-[20px]" }
const _hoisted_37 = { class: "grid grid-cols-10 sm:grid-cols-12 gap-2 sm:gap-3" }
const _hoisted_38 = { class: "col-span-8 sm:col-span-11" }
const _hoisted_39 = { class: "col-span-2 sm:col-span-1" }
const _hoisted_40 = {
  key: 0,
  class: "mt-[15px] flex flex-wrap"
}
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 1,
  class: "text-gray-500 dark:text-gray-400 text-sm mt-[10px]"
}
const _hoisted_43 = { class: "col-span-1 sm:col-span-2 mb-[15px] sm:mb-[20px]" }
const _hoisted_44 = { class: "grid grid-cols-10 sm:grid-cols-12 gap-2 sm:gap-3" }
const _hoisted_45 = { class: "col-span-8 sm:col-span-11" }
const _hoisted_46 = { class: "col-span-2 sm:col-span-1" }
const _hoisted_47 = {
  key: 0,
  class: "mt-[15px] flex flex-wrap"
}
const _hoisted_48 = ["onClick"]
const _hoisted_49 = {
  key: 1,
  class: "text-gray-500 dark:text-gray-400 text-sm mt-[10px]"
}
const _hoisted_50 = { class: "col-span-1 sm:col-span-2 mb-[15px] sm:mb-[20px]" }
const _hoisted_51 = { id: "fileUploader" }
const _hoisted_52 = { class: "relative flex items-center justify-center overflow-hidden rounded-md py-[60px] sm:py-[88px] px-[15px] sm:px-[20px] border border-gray-200 dark:border-[#172036]" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "flex flex-wrap gap-2 sm:gap-4" }
const _hoisted_55 = { class: "relative group" }
const _hoisted_56 = ["src"]
const _hoisted_57 = { class: "absolute inset-0 bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center rounded" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "mt-1 text-center" }
const _hoisted_61 = { class: "mt-[15px] sm:mt-[20px] md:mt-[25px] flex flex-col sm:flex-row" }
const _hoisted_62 = ["disabled"]
const _hoisted_63 = { class: "inline-block relative ltr:pl-[29px] rtl:pr-[29px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[37] || (_cache[37] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveProperty && _ctx.saveProperty(...args)), ["prevent"])),
    class: "w-full"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[38] || (_cache[38] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Property Title ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.property.title) = $event)),
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              placeholder: "Enter property title"
            }, null, 512), [
              [_vModelText, _ctx.property.title]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[40] || (_cache[40] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Property Status ", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.property.status) = $event)),
              class: "h-[55px] rounded-md border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[13px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500"
            }, _cache[39] || (_cache[39] = [
              _createStaticVNode("<option value=\"\">Select</option><option value=\"available\">Available</option><option value=\"rented\">Rented</option><option value=\"sold\">Sold</option><option value=\"pending\">Pending</option><option value=\"off-market\">Off Market</option>", 6)
            ]), 512), [
              [_vModelSelect, _ctx.property.status]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[42] || (_cache[42] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Rent or Sale ", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.property.rent_or_sale) = $event)),
              class: "h-[55px] rounded-md border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[13px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500"
            }, _cache[41] || (_cache[41] = [
              _createElementVNode("option", { value: "" }, "Select", -1),
              _createElementVNode("option", { value: "rent" }, "Rent", -1),
              _createElementVNode("option", { value: "sale" }, "Sale", -1)
            ]), 512), [
              [_vModelSelect, _ctx.property.rent_or_sale]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[43] || (_cache[43] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Property Price ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.property.price) = $event)),
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              placeholder: "Price",
              step: "0.01"
            }, null, 512), [
              [_vModelText, _ctx.property.price]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[45] || (_cache[45] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Property Type ", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.property.property_type) = $event)),
              class: "h-[55px] rounded-md border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[13px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500"
            }, _cache[44] || (_cache[44] = [
              _createStaticVNode("<option value=\"\">Select</option><option value=\"apartment\">Apartment</option><option value=\"house\">House</option><option value=\"townhouse\">Townhouse</option><option value=\"condo\">Condominium</option><option value=\"detached\">Detached House</option><option value=\"multifamily\">Multifamily</option><option value=\"bungalow\">Bungalow</option><option value=\"commercial\">Commercial</option><option value=\"land\">Land</option>", 10)
            ]), 512), [
              [_vModelSelect, _ctx.property.property_type]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[46] || (_cache[46] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Bedrooms ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.property.bedroom) = $event)),
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              placeholder: "2.5",
              step: "0.5"
            }, null, 512), [
              [_vModelText, _ctx.property.bedroom]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[47] || (_cache[47] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Bathrooms ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.property.bathroom) = $event)),
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              placeholder: "1.5",
              step: "0.5"
            }, null, 512), [
              [_vModelText, _ctx.property.bathroom]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[48] || (_cache[48] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Size (sqm) ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.property.size) = $event)),
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              placeholder: "Size in square meters",
              step: "0.01"
            }, null, 512), [
              [_vModelText, _ctx.property.size]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[49] || (_cache[49] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Year Built ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.property.year_built) = $event)),
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              placeholder: "2023"
            }, null, 512), [
              [_vModelText, _ctx.property.year_built]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[50] || (_cache[50] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Country ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.property.country) = $event)),
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              placeholder: "Country"
            }, null, 512), [
              [_vModelText, _ctx.property.country]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[51] || (_cache[51] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " City ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.property.city) = $event)),
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              placeholder: "City"
            }, null, 512), [
              [_vModelText, _ctx.property.city]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[52] || (_cache[52] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Address ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.property.address) = $event)),
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              placeholder: "Full address"
            }, null, 512), [
              [_vModelText, _ctx.property.address]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[53] || (_cache[53] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Floor ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.property.floor) = $event)),
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              placeholder: "Current floor"
            }, null, 512), [
              [_vModelText, _ctx.property.floor]
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[54] || (_cache[54] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Total Floors ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.property.total_floors) = $event)),
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              placeholder: "Total floors in building"
            }, null, 512), [
              [_vModelText, _ctx.property.total_floors]
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[55] || (_cache[55] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Availability Date ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.property.availability_date) = $event)),
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
            }, null, 512), [
              [_vModelText, _ctx.property.availability_date]
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[56] || (_cache[56] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Entry Type ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.property.entry_type) = $event)),
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              placeholder: "Immediate, 30 days, etc."
            }, null, 512), [
              [_vModelText, _ctx.property.entry_type]
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[57] || (_cache[57] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Parking ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.property.parking) = $event)),
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              placeholder: "Garage, Street, None, etc."
            }, null, 512), [
              [_vModelText, _ctx.property.parking]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[58] || (_cache[58] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Utilities Included ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.property.utilities_included) = $event)),
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              placeholder: "Water, Electricity, etc."
            }, null, 512), [
              [_vModelText, _ctx.property.utilities_included]
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "elevator",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.property.elevator) = $event)),
                class: "mr-2"
              }, null, 512), [
                [_vModelCheckbox, _ctx.property.elevator]
              ]),
              _cache[59] || (_cache[59] = _createElementVNode("label", {
                for: "elevator",
                class: "text-black dark:text-white"
              }, "Elevator", -1))
            ]),
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "furnished",
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.property.furnished) = $event)),
                class: "mr-2"
              }, null, 512), [
                [_vModelCheckbox, _ctx.property.furnished]
              ]),
              _cache[60] || (_cache[60] = _createElementVNode("label", {
                for: "furnished",
                class: "text-black dark:text-white"
              }, "Furnished", -1))
            ]),
            _createElementVNode("div", _hoisted_25, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "pets_allowed",
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.property.pets_allowed) = $event)),
                class: "mr-2"
              }, null, 512), [
                [_vModelCheckbox, _ctx.property.pets_allowed]
              ]),
              _cache[61] || (_cache[61] = _createElementVNode("label", {
                for: "pets_allowed",
                class: "text-black dark:text-white"
              }, "Pets Allowed", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _cache[63] || (_cache[63] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Assign To Agent ", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.property.assigned_to) = $event)),
              class: "h-[55px] rounded-md border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[13px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500"
            }, [
              _cache[62] || (_cache[62] = _createElementVNode("option", { value: "" }, "Select Agent", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: user.id,
                  value: user.id
                }, _toDisplayString(user.display_name), 9, _hoisted_27))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.property.assigned_to]
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _cache[64] || (_cache[64] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Description ", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.property.description) = $event)),
              class: "h-[150px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] py-[10px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              placeholder: "Property description"
            }, null, 512), [
              [_vModelText, _ctx.property.description]
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _cache[67] || (_cache[67] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Features ", -1)),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] py-[15px] w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                  placeholder: "Add a feature",
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.newFeature) = $event)),
                  onKeyup: _cache[24] || (_cache[24] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addFeature && _ctx.addFeature(...args)), ["enter"])),
                  onKeydown: _cache[25] || (_cache[25] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.newFeature]
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("button", {
                  type: "button",
                  class: "h-[55px] w-full rounded-md bg-primary-500 text-white flex items-center justify-center hover:bg-primary-400 transition-colors",
                  onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.addFeature && _ctx.addFeature(...args)))
                }, _cache[65] || (_cache[65] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "add", -1)
                ]))
              ])
            ]),
            (_ctx.property.features && _ctx.property.features.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.property.features, (feature, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "inline-flex items-center mb-[10px] mr-[10px] py-[6px] px-[12px] bg-primary-500 text-white rounded-md"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(feature), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "text-white hover:text-gray-200 transition-colors ml-[10px]",
                        onClick: ($event: any) => (_ctx.removeFeature(index))
                      }, _cache[66] || (_cache[66] = [
                        _createElementVNode("i", { class: "ri-close-line" }, null, -1)
                      ]), 8, _hoisted_34)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_35, " No features added yet. Add some features that make this property stand out. "))
          ]),
          _createElementVNode("div", _hoisted_36, [
            _cache[70] || (_cache[70] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Neighborhood Info ", -1)),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] py-[15px] w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                  placeholder: "Add neighborhood info",
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.newNeighborhoodInfo) = $event)),
                  onKeyup: _cache[28] || (_cache[28] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addNeighborhoodInfo && _ctx.addNeighborhoodInfo(...args)), ["enter"])),
                  onKeydown: _cache[29] || (_cache[29] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.newNeighborhoodInfo]
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("button", {
                  type: "button",
                  class: "h-[55px] w-full rounded-md bg-primary-500 text-white flex items-center justify-center hover:bg-primary-400 transition-colors",
                  onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.addNeighborhoodInfo && _ctx.addNeighborhoodInfo(...args)))
                }, _cache[68] || (_cache[68] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "add", -1)
                ]))
              ])
            ]),
            (_ctx.property.neighborhood_info && _ctx.property.neighborhood_info.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.property.neighborhood_info, (info, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "inline-flex items-center mb-[10px] mr-[10px] py-[6px] px-[12px] bg-primary-500 text-white rounded-md"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(info), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "text-white hover:text-gray-200 transition-colors ml-[10px]",
                        onClick: ($event: any) => (_ctx.removeNeighborhoodInfo(index))
                      }, _cache[69] || (_cache[69] = [
                        _createElementVNode("i", { class: "ri-close-line" }, null, -1)
                      ]), 8, _hoisted_41)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_42, " No neighborhood information added yet. Add some details about the area. "))
          ]),
          _createElementVNode("div", _hoisted_43, [
            _cache[73] || (_cache[73] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Recent Renovations ", -1)),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] py-[15px] w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                  placeholder: "Add renovation detail",
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.newRenovation) = $event)),
                  onKeyup: _cache[32] || (_cache[32] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addRenovation && _ctx.addRenovation(...args)), ["enter"])),
                  onKeydown: _cache[33] || (_cache[33] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.newRenovation]
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("button", {
                  type: "button",
                  class: "h-[55px] w-full rounded-md bg-primary-500 text-white flex items-center justify-center hover:bg-primary-400 transition-colors",
                  onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.addRenovation && _ctx.addRenovation(...args)))
                }, _cache[71] || (_cache[71] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "add", -1)
                ]))
              ])
            ]),
            (_ctx.property.recent_renovations && _ctx.property.recent_renovations.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.property.recent_renovations, (renovation, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "inline-flex items-center mb-[10px] mr-[10px] py-[6px] px-[12px] bg-primary-500 text-white rounded-md"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(renovation), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "text-white hover:text-gray-200 transition-colors ml-[10px]",
                        onClick: ($event: any) => (_ctx.removeRenovation(index))
                      }, _cache[72] || (_cache[72] = [
                        _createElementVNode("i", { class: "ri-close-line" }, null, -1)
                      ]), 8, _hoisted_48)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_49, " No renovation details added yet. Add some recent upgrades or improvements to the property. "))
          ]),
          _createElementVNode("div", _hoisted_50, [
            _cache[78] || (_cache[78] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Add Property Photos ", -1)),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _cache[74] || (_cache[74] = _createStaticVNode("<div class=\"flex items-center justify-center\"><div class=\"w-[35px] h-[35px] border border-gray-100 dark:border-[#15203c] flex items-center justify-center rounded-md text-primary-500 text-lg ltr:mr-[12px] rtl:ml-[12px]\"><i class=\"ri-upload-2-line\"></i></div><p class=\"leading-[1.5]\"><strong class=\"text-black dark:text-white\"> Click to upload </strong><br> images for gallery </p></div>", 1)),
                _createElementVNode("input", {
                  type: "file",
                  id: "fileInput",
                  multiple: "",
                  onChange: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.handleImageUpload && _ctx.handleImageUpload(...args))),
                  class: "absolute top-0 left-0 right-0 bottom-0 rounded-md z-[1] opacity-0 cursor-pointer",
                  accept: "image/*"
                }, null, 32)
              ]),
              (_ctx.uploadedImages.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _cache[77] || (_cache[77] = _createElementVNode("div", { class: "mt-4 mb-2 text-sm font-medium text-gray-700 dark:text-gray-300" }, " Select a main image for the property: ", -1)),
                    _createElementVNode("div", _hoisted_54, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadedImages, (image, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "relative w-full sm:w-auto"
                        }, [
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("img", {
                              src: image.preview,
                              class: "w-full sm:w-32 h-32 object-cover rounded"
                            }, null, 8, _hoisted_56),
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("button", {
                                onClick: _withModifiers(($event: any) => (_ctx.removeImage(index)), ["prevent"]),
                                class: "bg-red-500 text-white w-8 h-8 rounded-full flex items-center justify-center m-1",
                                title: "Remove image"
                              }, _cache[75] || (_cache[75] = [
                                _createElementVNode("i", { class: "ri-delete-bin-line" }, null, -1)
                              ]), 8, _hoisted_58),
                              _createElementVNode("button", {
                                onClick: _withModifiers(($event: any) => (_ctx.setMainImage(index)), ["prevent"]),
                                class: "bg-primary-500 text-white w-8 h-8 rounded-full flex items-center justify-center m-1",
                                title: "Set as main image"
                              }, _cache[76] || (_cache[76] = [
                                _createElementVNode("i", { class: "ri-star-line" }, null, -1)
                              ]), 8, _hoisted_59)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["text-xs px-2 py-1 rounded", _ctx.mainImageIndex === index ? 'bg-primary-500 text-white' : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300'])
                            }, _toDisplayString(_ctx.mainImageIndex === index ? 'Main Image' : 'Gallery Image'), 3)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.$router.push('/real-estate/property-list'))),
            class: "font-medium mb-3 sm:mb-0 text-center sm:text-left transition-all rounded-md md:text-md py-[10px] md:py-[12px] px-[20px] md:px-[22px] bg-danger-500 text-white hover:bg-danger-400"
          }, " Cancel "),
          _createElementVNode("button", {
            type: "submit",
            class: "font-medium text-center sm:text-left transition-all rounded-md md:text-md py-[10px] md:py-[12px] px-[20px] md:px-[22px] bg-primary-500 text-white hover:bg-primary-400 sm:ltr:ml-[15px] sm:rtl:mr-[15px]",
            disabled: _ctx.isLoading
          }, [
            _createElementVNode("span", _hoisted_63, [
              _cache[79] || (_cache[79] = _createElementVNode("i", { class: "material-symbols-outlined ltr:left-0 rtl:right-0 absolute top-1/2 -translate-y-1/2" }, " add ", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.isLoading ? 'Saving...' : 'Create Property'), 1)
            ])
          ], 8, _hoisted_62)
        ])
      ])
    ])
  ], 32))
}